const baseUrl = import.meta.env.VITE_API_BASE_URL;
const DEFAULT_REQUEST_TIMEOUT_MS = 30000;
function getUrl(relativePath) {
    return baseUrl + "/api/" + relativePath;
}
const baseService = {
    postJson: async function(relativePath, body, timeoutMs) {
        const url = getUrl(relativePath);
        const bodyString = typeof body === "string" ? body : JSON.stringify(body);
        const requestTimeout = timeoutMs || DEFAULT_REQUEST_TIMEOUT_MS;
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), requestTimeout);
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: bodyString,
                signal: controller.signal
            });
            return response;
        } finally {
            clearTimeout(timeoutId);
        }
    }
};
export default baseService;